
import {Route, Routes} from 'react-router-dom';
import PrivateRoutes from './PrivateRoutes';
import FullLayout from '../components/AdminLayout/FullLayout';
import Login from '../components/Login';
import OtpVerification from '../components/OtpVerification';

import AdminDashboard from '../components/AdminDashboard';
import Userslist from '../components/Userslist';
import UserAdd from '../components/UserAdd';
import UserEdit from '../components/UserEdit';
import EmailList from '../components/EmailTemplate/EmailList';
import EmailEdit from '../components/EmailTemplate/EmailEdit';

import ApiUsers from '../components/User/ApiUsers';
import AddApiUser from '../components/User/AddApiUser';
import EditApiUser from '../components/User/EditApiUser';

import StaticContentList from '../components/StaticContent/StaticContentList';
import StaticContentEdit from '../components/StaticContent/StaticContentEdit';

import FaqList from '../components/FAQ/FaqList';
import FaqEdit from '../components/FAQ/FaqEdit';
import FaqAdd from '../components/FAQ/FaqAdd';

import ExcelDownload from '../components/Excel/Download';

export default function AllRoutes() {
  return (
    <div>
      <Routes>
        <Route exact element={<PrivateRoutes />}>
          <Route path="/" element={<FullLayout />}>       
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/users-list" element={<Userslist />} />
            <Route path="/admin/api-users" element={<ApiUsers />} />
            <Route path="/admin/add-user" element={<UserAdd />} />
            <Route path="/admin/api-users/add" element={<AddApiUser/>} />
            <Route path="/admin/api-users/edit" element={<EditApiUser/>} />
            <Route path="/admin/edit-user" element={<UserEdit />} />
            <Route path="/admin/email-list" element={<EmailList />} />
            <Route path="/admin/email-edit" element={<EmailEdit />} />
            <Route path="/admin/static-content-list" element={<StaticContentList />} />
            <Route path="/admin/static-content-edit" element={<StaticContentEdit />} />
            <Route path="/admin/faq-list" element={<FaqList />} />
            <Route path="/admin/faq-edit" element={<FaqEdit />} />
            <Route path="/admin/faq-add" element={<FaqAdd />} />
            <Route path="/admin/download-excel" element={<ExcelDownload />} />
          </Route>
        </Route>
        <Route path="/admin/login" element={<Login />} />
        <Route path="/otp-verification" element={<OtpVerification />} />
        <Route path="/*" element={<Login />} />
      </Routes>
    </div>
  );
}
